"use client";

import React from "react";
import {
  Box,
  Container,
  Flex,
  Stack,
  VStack,
  Text,
  HStack,
  useMediaQuery,
  IconButton,
  Divider,
} from "@chakra-ui/react";
import { FaInstagram, FaTwitter, FaLinkedin, FaFacebook } from "react-icons/fa";
import { merriweatherSansFont } from "../../styles/theme/fonts";
import { useRouter } from "next/navigation";

const Footer = () => {
  const [isSmallerThan768] = useMediaQuery("(max-width: 768px)");
  const router = useRouter();

  const navigate = (path: string) => {
    router.push(path);
  };

  const linkStyle: React.CSSProperties = {
    fontStyle: "normal",
    fontSize: "0.875rem",
    fontWeight: "normal",
    fontFamily: merriweatherSansFont.style.fontFamily,
    color: "white",
    cursor: "pointer",
  };

  const currentYear = new Date().getFullYear();
  return (
    <Box bg={"blue.900"} pt={10} pb={6} color={"white"}>
      <Container maxW={"6xl"}>
        <Stack
          direction={["column", "column", "row"]}
          justify="space-between"
          spacing={10}
        >
          {/* Company */}
          <VStack align="start" spacing={2}>
            <Text
              fontWeight="bold"
              fontSize="md"
              fontFamily={merriweatherSansFont.style.fontFamily}
            >
              Company
            </Text>

            <Text onClick={() => navigate("/about")} style={linkStyle}>
              About Us
            </Text>
            <Text onClick={() => navigate("/contact")} style={linkStyle}>
              Contact Us
            </Text>
            <Text onClick={() => navigate("/faq")} style={linkStyle}>
              FAQs
            </Text>
            <Text onClick={() => navigate("/terms")} style={linkStyle}>
              Terms & Conditions
            </Text>
            <Text onClick={() => navigate("/privacypolicy")} style={linkStyle}>
              Privacy Policy
            </Text>
            <Text onClick={() => navigate("/announcements")} style={linkStyle}>
              Announcements
            </Text>
          </VStack>

          {/* Explore */}
          <VStack align="start" spacing={2}>
            <Text
              fontWeight="bold"
              fontSize="md"
              fontFamily={merriweatherSansFont.style.fontFamily}
            >
              Explore
            </Text>
            <Text>Top Services</Text>
            <Text>Browse Categories</Text>
            <Text onClick={() => navigate("/signup")} style={linkStyle}>
              List Your Business
            </Text>
          </VStack>

          {/* Contact Info */}
          <VStack align="start" spacing={2}>
            <Text
              fontWeight="bold"
              fontSize="md"
              fontFamily={merriweatherSansFont.style.fontFamily}
            >
              Contact
            </Text>
            <Text style={linkStyle}>Email: support@nearnist.com</Text>
            <Text style={linkStyle}>Phone: +91 8378989368</Text>
            <Text style={linkStyle}>Mon - Sat : 10AM - 6PM</Text>
          </VStack>

          {/* Social Media */}
          <VStack align="start" spacing={2}>
            <Text
              fontWeight="bold"
              fontSize="md"
              fontFamily={merriweatherSansFont.style.fontFamily}
            >
              Follow Us
            </Text>
            <HStack spacing={4}>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconButton
                  aria-label="Instagram"
                  icon={<FaInstagram />}
                  variant="ghost"
                  color="white"
                  fontSize="1.25rem"
                />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconButton
                  aria-label="LinkedIn"
                  icon={<FaLinkedin />}
                  variant="ghost"
                  color="white"
                  fontSize="1.25rem"
                />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nooper noreferrer"
              >
                <IconButton
                  aria-label="Facebook"
                  icon={<FaFacebook />}
                  variant="ghost"
                  color="white"
                  fontSize="1.25rem"
                />
              </a>
            </HStack>
          </VStack>
        </Stack>

        <Divider my={6} borderColor="gray.600" />

        {/* Footer Bottom */}
        <Flex
          direction={["column", "row"]}
          justify="space-between"
          align="center"
        >
          <HStack spacing={3} mb={[4, 0]}>
            <Text
              fontSize="sm"
              fontFamily={merriweatherSansFont.style.fontFamily}
            >
              © {currentYear} nearnist. All rights reserved.
            </Text>
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
